import React, {useState, useEffect, useCallback} from 'react'
import styled from 'styled-components'
import { useActiveWeb3React } from '../hooks'
import SetInput from '../components/Settings/SetInput'
import Column from '../components/Column'
import { ButtonCheck } from '../components/Button'

import { deepCopy, sessionStore } from '../utils/func'

const Wrapper = styled.div``

const Mask = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(17, 15, 13, 0.94);
  left: 0px;
  top: 0px;
`

const ContentLimit = styled.div`
  background: #FFF3E0;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10000;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  margin:auto;
  padding: 72px 10px;
  overflow: auto;
  @media screen and (max-width: 500px) {
    width: 100%;
    height: 100%;
  }
`
const Element = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 500px) {
    width: 100%;
    height: 100%;
  }
`
const Image = styled.img`
  width: 118px;
  height: 118px;
  display: block;
  margin: 0 0;
  flex-shrink: 0;
  @media screen and (max-width: 500px) {
    width: 54px;
    height: 43px;
  }
`
const FormElement = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: 30px;
  margin: 50px auto 0;
  width: 380px;
  @media screen and (max-width: 500px) {
    width: 100%;
    padding: 0 16px;
  }
`
const FormColumn = styled(Column)`
  height: 70px;
`
const Text = styled.div`
  margin: 0 0 5px;
  width: 100%;
  height: 20px;
  @media screen and (max-width: 500px) {
  }
`
const Button = styled(ButtonCheck)`
  position: relative;
  padding: 12px 0;
  margin: 20px auto 0;
  height: 45px;

  .err {
    position: absolute;
    top: -20px;
    height: 15px;
    color: #ff4473;
    font-size: 12px;
    font-weight: 400;
    font-family: 'Inter var', sans-serif;
  }
`

export default function CheckTest() {
  const { chainId } = useActiveWeb3React()
  const [isLimited, setIsLimited] = useState(false)
  const [requestLoading, setRequestLoading] = useState(false)
  const [submitErr, setSubmitErr] = useState(false)
  const [info, setInfo] = useState({
      account: {
        title: 'Account',
        value: '',
        id: 'account',
        placeholder: 'please enter account',
        errorMsg: 'please enter account',
        saveError: false,
      },
      password: {
        title: 'Password',
        value: '',
        id: 'password',
        placeholder: 'please enter password',
        errorMsg: 'please enter password',
        saveError: false,
      }
  })

  const changeInput = useCallback(
    (e: any) => {
      setSubmitErr(false)
      const obj: any = {...deepCopy(info)}
      const value = e.target.value.replace(/[\u4e00-\u9fa5]/ig, '').trim()
      obj[e.target.id]['value'] = value
      setInfo(obj)
    },
    [info]
  )

  const handleSubmit = useCallback(() => {
    const newInfo = { ...deepCopy(info) }
    for (const key in newInfo) {
      if (Object.prototype.hasOwnProperty.call(newInfo, key)) {
        if (!newInfo[key].value) {
          newInfo[key].saveError = true
        }
      }
    }
    setInfo(newInfo)
    if (!info.account.value || !info.password.value) return
    if (info.account.value !== 'bakery2022' || info.password.value !== 'bakery2022..') {
      setSubmitErr(true)
    }
    setRequestLoading(true)
    if (info.account.value === 'bakery2022' && info.password.value === 'bakery2022..') {
      // sessionStore.set('checktest', new Date().getTime() + 432000000 + '')
      sessionStore.set('checktest', 'checktest')
      setIsLimited(false)
    }
    setRequestLoading(false)
  }, [info])

  const fetchLimitIp = useCallback(() => {
    const check = sessionStore.get('checktest')
    // if (!check || (check && +check <= new Date().getTime())) {
    //   setIsLimited(true)
    // }
    if (!check) {
      setIsLimited(true)
    }
  },[chainId])

  useEffect(() => {
    fetchLimitIp()
  }, [fetchLimitIp])

  return (
    isLimited ? (
      <Wrapper>
        <Mask/>
        <ContentLimit>
          <Element>
            <Image src="/images/icon/message.png"/>
            <FormElement>
              <FormColumn>
                <Text>{info?.account?.title}</Text>
                <SetInput
                  height="45px"
                  borderColor="rgba(239,129,49)"
                  errorBorder={true}
                  size="16px"
                  value={info?.account?.value}
                  id={info?.account?.id}
                  placeholder={info?.account?.placeholder}
                  errorMsg={info?.account?.errorMsg}
                  saveError={!info?.account?.value && info?.account?.saveError}
                  inputBlur={null}
                  inputChange={changeInput}
                ></SetInput>
              </FormColumn>
              <FormColumn>
                <Text>{info?.password?.title}</Text>
                <SetInput
                  height="45px"
                  borderColor="rgba(239,129,49)"
                  errorBorder={true}
                  size="16px"
                  value={info?.password?.value}
                  id={info?.password?.id}
                  placeholder={info?.password?.placeholder}
                  errorMsg={info?.password?.errorMsg}
                  saveError={!info?.password?.value && info?.password?.saveError}
                  inputBlur={null}
                  inputChange={changeInput}
                ></SetInput>
              </FormColumn>
              <Button
                onClick={handleSubmit}
                disabled={requestLoading}
                altDisabledStyle={requestLoading} 
              >
                Submit
                {
                  submitErr && <span className="err">Incorrect account or password</span>
                }
              </Button>
            </FormElement>
          </Element>
        </ContentLimit>
      </Wrapper>
    ) : null
  )
}
